import Svg, { Path } from 'react-native-svg'

export const FaqArrowRight = ({ height = 24, width = 24, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M10 17a1.002 1.002 0 0 1-1.006-1 1 1 0 0 1 .296-.71l3.3-3.29-3.3-3.29a1.004 1.004 0 0 1 1.42-1.42l4 4a.997.997 0 0 1 .219 1.095.999.999 0 0 1-.22.325l-4 4A1 1 0 0 1 10 17Z"
      />
    </Svg>
  )
}
